<template>
  <div class="reserve" v-loading="loading" ref="all">
    <div class="leftRe">
      <div>
        <div class="reTop">
          <img @click="styleCheck(i)" v-for="(v, i) in styleList" :key="i"
            :src="styleCurrentList == i ? v.CurrentImg:v.imgUrl" width="28px" height="28px" :title="v.text" />

        </div>

        <div class="eatingAll">
          <div v-for="(v,i) in cantList" :key="i" class="eatingItem" :class="v.check ? 'eatingCurrent' : '' "
            @click="addEatingItem(v,i)">
            {{v.description}}
          </div>
        </div>
        <div class="timeAll">
          <!-- <div v-for="(v,i) in cbList" :key="i" class="timeItem"
            :class="timecurrent.indexOf(i) != -1 ? 'timeCurrent' : '' " @click="addtimeItem(i)">
            {{v.description}}
          </div> -->
          <div>状态实例</div>
          <div class="yandq">
            <div>预订（R）</div>
            <!-- <div>开台（U）</div> -->
            <div>空闲（V）</div>
            <!-- <div>锁定（F）</div> -->
          </div>
        </div>
      </div>

    </div>
    <div class="rightMain">
      <div class="rightTop">
        <div class="Screening ">

          <!-- <div style="color:#bdbdbd;cursor:pointer" v-if="staus == 2" @click="staus = 1">列表</div>
          <div style="color:#bdbdbd;cursor:pointer" v-else @click="staus = 2">网格</div> -->
          <div>

            <el-date-picker v-model="value1" value-format="yyyy-MM-dd" type="daterange" @change="timegetList"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </div>
          <div>

            <el-input v-if="styleCurrentList == 1" v-model="changeInput" style="width:350px"
              placeholder="输入预定名称、联系人、联系方式桌号快速查找" @input="fetchListData" suffix-icon="el-icon-search">

            </el-input>
          </div>
          <div>

            <!--  <el-radio-group v-model="radio" >
            <el-radio label="R">预订</el-radio>
            <el-radio label="ALL">取消</el-radio>
          </el-radio-group> -->
            <el-checkbox-group v-model="radio" @change="changeRorAll" v-if="styleCurrentList == 1">
              <el-checkbox label="R">预订</el-checkbox>
              <!-- <el-checkbox label="ALL">开台</el-checkbox> -->
              <el-checkbox label="X">取消</el-checkbox>
            </el-checkbox-group>
          </div>
          <div>

            <el-radio-group v-model="radio" @change="changeRorAll" v-if="styleCurrentList == 2">
              <el-radio label="NEED_SETTLED">未结</el-radio>
              <el-radio label="SETTLED">已结</el-radio>
              <el-radio label="refund">退款</el-radio>
              <el-radio label="ALL">所有</el-radio>
            </el-radio-group>
          </div>

        </div>
        <div class="FunctionalityBtn">
          <div class="feffBtn" @click="gotoadd">新增预订</div>
          <!-- <div class="blueBtn">打印</div> -->
          <!-- <div class="blueBtn">导出</div> -->
          <!-- <div class="blueBtn" @click="$router.go(0)">刷新</div> -->
        </div>
      </div>
      <!-- 列表 -->
      <div style="height:calc(100% - 90px);width:calc(100vw - 180px)" v-if="styleCurrentList == 1">
        <el-table :data="tableData" ref="tableData" :max-height="orderHeight" size='mini' show-summary
          :summary-method="getSummaries" @cell-dblclick="getAddreserve">
          <el-table-column prop="order_num" width="120" show-overflow-tooltip label=" 订单号 " align="center" sortable>
          </el-table-column>
          <el-table-column prop="book_name" sortable show-overflow-tooltip label=" 预定名称" align="center" width="120">
          </el-table-column>
          <el-table-column prop="contact_name" sortable show-overflow-tooltip label="联系人" align="center" width="120">
          </el-table-column>
          <el-table-column prop="contact_tele" sortable show-overflow-tooltip label="电话" align="center" width="120">
          </el-table-column>
          <el-table-column prop="outletsName" sortable show-overflow-tooltip label="营业点" align="center" width="120">
          </el-table-column>
          <el-table-column prop="tableCode" sortable label=" 桌号/包厢" show-overflow-tooltip width="120" align="center">
          </el-table-column>
          <el-table-column label="状态" show-overflow-tooltip align="center">
            <template slot-scope="scope">

              {{scope.row.status == 'R' ? '预订' :scope.row.status == 'X' ? '取消' : '无' }}
            </template>
          </el-table-column>
          <el-table-column prop="bookArriveTime" sortable show-overflow-tooltip label="到达日期" width="120" align="center">
          </el-table-column>
          <el-table-column prop="mealDiffer" sortable show-overflow-tooltip label="使用时段" width="120" align="center">
          </el-table-column>
          <el-table-column prop="peopleCount" sortable show-overflow-tooltip label="人数" align="center">
          </el-table-column>
          <el-table-column prop="tableCount" sortable label=" 桌数" show-overflow-tooltip align="center">
          </el-table-column>
          <el-table-column prop="order_all_price" width="120" sortable label="预点餐" show-overflow-tooltip align="right">

            <template slot-scope="scope">
              <div style="text-align:right">
                {{(scope.row.order_all_price*1).toFixed(2)}}

              </div>
            </template>
          </el-table-column>
          <el-table-column prop="total_price" width="120" sortable label="订金" show-overflow-tooltip align="right">

            <template slot-scope="scope">
              <div style="text-align:right">
                {{(scope.row.total_price*1).toFixed(2)}}

              </div>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="cust_name" label="客人姓名" show-overflow-tooltip width="100" align="center">
          </el-table-column>
          <el-table-column prop="corp_name" label="单位" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="discountName" label="折扣模式" show-overflow-tooltip width="100" align="center">
          </el-table-column>
          <el-table-column prop="selaName" label="销售员" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="createUser" label="操作人" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="createDate" label="操作时间" show-overflow-tooltip align="center" width="100">
          </el-table-column>
        </el-table>
      </div>
      <div style="width:calc(100vw - 180px)" v-if="styleCurrentList == 2">
        <el-table :data="bookBillList" ref="bookBillList" :max-height="bookheight" size='mini'
          @current-change="handleCurrentChange" show-summary :summary-method="getSummarie">
          <!-- <el-table-column type="index" label=""></el-table-column> -->
          <el-table-column prop="order_num" sortable show-overflow-tooltip width="140" label="订单号" align="center">
          </el-table-column>
          <el-table-column prop="book_name" sortable show-overflow-tooltip label="预订名称" width="140" align="center">
          </el-table-column>
          <el-table-column prop="contact_name" sortable label="联系人" show-overflow-tooltip align="center">
          </el-table-column>
          <el-table-column prop="contact_tele" sortable width="140" show-overflow-tooltip label="联系方式" align="center">
          </el-table-column>
          <el-table-column prop="outletsName" sortable label="营业点" align="center"></el-table-column>
          <el-table-column prop="tableCode" label="桌号/包厢" sortable align="center"></el-table-column>
          <el-table-column prop="status" label="押金状态" align="center">
            <template slot-scope="scope">
              {{scope.row.status == 'SETTLED' ? '结账' :scope.row.status == 'NEED_SETTLED' ? '未结账 ' :   scope.row.status == 'INVALID' ? '无效账' : '无' }}
            </template>
          </el-table-column>
          <el-table-column prop="business_date" sortable show-overflow-tooltip label="入账日期" align="center">
          </el-table-column>
          <el-table-column prop="totalPrice" label="订金" sortable align="center"></el-table-column>
          <el-table-column prop="bill_no" sortable show-overflow-tooltip label="订金单号" align="center">

          </el-table-column>
          <el-table-column prop="empName" label="操作员" align="center"></el-table-column>
          <el-table-column prop="create_date" show-overflow-tooltip label="操作时间" align="center" width="100">
          </el-table-column>
          <el-table-column prop="remark" label="订金备注" width="100" show-overflow-tooltip align="center">
          </el-table-column>
          <!-- <el-table-column prop="address" label="操作" align="center">
            <template slot-scope="scope">
              <div>补打</div>
            </template>
          </el-table-column> -->

        </el-table>
      </div>
      <!-- 表格 -->
      <div style="height:calc(100% - 66px);width:calc(100vw - 180px)" v-show="styleCurrentList == 0">
        <div class="atrialState" v-if="contentList.length &&  contentList[0].tableVos.length ">

          <div class="mainDisplay">
            <div class="ssss">
              <div class="topLeft">
                <div class="topTile">
                  营业点/台号
                </div>

                <div class="mainContent" v-for=" (value, index) in contentList[0].tableVos" :key="value+index">
                  <div class="ctDiv" v-if="value.outletsName">
                    <div>{{value.outletsName}}{{value.mealTableCode}} </div>
                  </div>
                </div>
                <div class="topBottom" style="width:120px;">
                  合计
                </div>
              </div>

            </div>
            <!-- </div> -->

            <div v-for="(item,ii) in contentList" :key="item+ii" :style="ii==0 ? 'margin-left:150px' : ''">

              <div>
                <div class="topTime">
                  <!-- <div style="width:120px" v-if="item.showName !== 1">
                    营业点/台号
                  </div> -->
                  <div class="titleDiv">
                    <div class="timeDiv">
                      <div style="text-align:center">{{item.businessDate}}</div>

                      <div class="zzwyj">
                        <div v-for="(vv,ii) in item.TopTimeList" :key="vv+ii">

                          <div>

                          </div>
                          <el-tooltip class="item" effect="dark" :content="vv.begin[0]+'-'+vv.end[0]" placement="bottom">
                            <div>
                              {{vv.description}}
                            </div>
                          </el-tooltip>


                        </div>
                        <!-- <div>{{item.time2}}</div> -->
                        <!-- <div>{{item.time3}}</div> -->
                        <!-- <div>{{item.time4}}</div> -->
                      </div>
                    </div>
                    <div class="titleTotal">计</div>
                  </div>
                </div>
                <div class="mainContent" v-for=" (value, index) in item.tableVos" :key="value+index">
                  <!-- <div class="ctDiv" v-if="value.outletsName">
                    <div>{{value.outletsName}}{{value.mealTableCode}} </div>
                  </div> -->
                  <div class="mainColor">
                    <div class="bgColor" @click="gotoAddreserve(item,value,v)" v-for="(v,i) in value.differVos" :key="i"
                      :style="{background:v.status=='R' ? '#ff9900' : v.status == 'G' ? '#4CBF56' : ''}"></div>
                    <div class="totalColor">{{value.num}}</div>
                  </div>
                </div>
              </div>

              <div class="bottomTotal">

                <div class="zzwyj" v-if="item.tableVos.length">
                  <div>{{item.zaoNum}}</div>
                  <div>{{item.zhongNum}}</div>
                  <div>{{item.wanNum}}</div>
                  <div>{{item.yeNum}}</div>
                  <div>{{item.zaoNum + item.zhongNum +item.wanNum +item.yeNum }}</div>
                </div>
              </div>

            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        contentList: [{
            time: '2021-06-01 周三',
            TopTimeList: ['早', '中', '晚', '夜', '计'],
            showName: 1,
            num1: '1',
            num2: '1',
            num3: '1',
            num4: '1',
            totalNum: '10',
            mainList: [

            ],
          },

        ],
        styleCurrentList: '0',
        styleList: [{
            imgUrl: require("../../assets/imgs/dish4.png"),
            CurrentImg: require("../../assets/imgs/dish4c.png"),
            text: '预订分布'
          },
          {
            imgUrl: require("../../assets/imgs/dish3.png"),
            CurrentImg: require("../../assets/imgs/dish3c.png"),
            text: '预订列表'

          },
          {
            imgUrl: require("../../assets/imgs/dish5c.png"),
            CurrentImg: require("../../assets/imgs/dish5.png"),
            text: '押金列表'

          }
        ],
        Determined: 2,
        staus: 0,
        tableData: [

        ],
        eating: ['早餐', '西餐', '中餐', '清餐'],
        timeArr: ['早', '中', '晚', '夜'],
        eatCurrent: [],
        timecurrent: [],
        value1: [],
        radio: ['R'],
        timevalue1: '',
        yyd: '',
        cantList: [],
        cantingIDList: [],
        mealDifferIds: [1, 2, 3, 4],
        cbList: [],
        cbIDlist: [],
        outletsIdsList: [],
        ydList: [],
        TopTimeList: ['早', '中', '晚', '夜'],
        loading: true,
        mealDifferIdsList: [],
        bookBillList: [],
        changeInput: null,
        orderHeight: 800,
        bookheight: 800
      }
    },
    created() {
      this.getByPosCode()
      this.getOutletsIdList()
      this.getNowFormatDate()
      setTimeout(() => {
        this.bookGrid()
      }, 1000)
    },
    watch: {
      contentList(val) {
        for (var i = 1; i < val.length; i++) {
          val[i].tableVos.forEach(v => {
            val[i].showName = 1
            this.$set(val[i], 'showName', 1)
            // delete v.mealTableCode
            // delete v.outletsName
          })
        }
        console.log(val);
      }
    },
    methods: {
      handleCurrentChange(v) {
        console.log(v);
        let url = this.api.orderByTable + '?tableId=' + v.id + '&status=' + v.status
        let methods = 'get'

        this.$axios({
          url,
          methods
        }).then(res => {


        })

      },
      getAddreserve(e) {
        console.log(e);
        let obj = {
          id: e.id
        }
        this.$router.push({
          path: 'reserve/addreserve',
          query: obj
        })
      },
      gotoAddreserve(item, value, v) {
        console.log(item);
        console.log(1213234, value);
        console.log(v);
        let url = this.api.orderDishesList2 + '?orderRecordId=' + v.orderRecordId
        let methods = 'get'
        let obj = {
          bookArriveTime: item.businessDate,
          ChongFoodName: value.outletsName,
          ChongFoodNum: value.mealTableCode,
          mealDiffer: v.differDesc,
          mealID: v.differId,
          mealTableId: value.mealTableId,
          id: v.orderRecordId
        }
        this.$router.push({
          path: 'reserve/addreserve',
          query: obj
        })
        //查询此餐桌是否点菜
        //   if (v.orderRecordId) {
        //     this.$axios({
        //   url,
        //   methods
        // }).then(res => {
        //   console.log('res.data.data', res.data.data);
        //   if (!res.data.status) {
        //     if (res.data.data == undefined) {
        //       this.$router.push({
        //         path: 'reserve/addreserve',
        //         query: obj
        //       })
        //     } else {

        //       this.$router.push({
        //         path: 'reserve/addreserve',
        //         query: res.data.data
        //       })

        //     }

        //   }

        // })
        // }else{
        //     this.$router.push({
        //         path: 'reserve/addreserve',
        //         query: obj
        //       })
        // }


      },
      getSummarie() {
        let sum = ['', '合计', '', '', '', '', '', '', '']
        let totalPrice = 0
        this.bookBillList.forEach(res => {
          totalPrice = totalPrice + res.totalPrice * 1
        })
        sum[2] = this.bookBillList.length + '条'
        sum[10] = (totalPrice * 1).toFixed(2)
        return sum
      },
      getSummaries() {
        let sum = ['合计', '', '', '', '', '', '']
        let totalPrice = 0
        let all_price = 0
        this.tableData.forEach(res => {
          totalPrice = totalPrice + res.total_price * 1
          all_price = all_price + res.order_all_price * 1
        })
        sum[1] = this.tableData.length + '条'
        // sum[9] = '预点餐'+(totalPrice * 1).toFixed(2)
        sum[11] = (all_price * 1).toFixed(2)
        sum[12] = (totalPrice * 1).toFixed(2)
        return sum
      },
      changeRorAll(v) {
        this.radio = v
        if (this.styleCurrentList == 1) {
          this.fetchListData()

        } else {
          console.log(v);

          this.getbookBillList()
        }
      },
      timegetList() {

        this.fetchListData()
        this.bookGrid()
        this.getbookBillList()
      },
      getByPosCode() {
        let methods = 'get'
        let url = this.api.getByList
        let data = {
          posCode: localStorage.getItem('posCode')
        }
        //时间
        this.$axios({
          methods,
          url,
          data
        }).then(res => {
          console.log(123124, res.data.data);
          this.mealDifferIdsList = []
          this.TopTimeList = []
          res.data.data.forEach((v, i) => {

            this.TopTimeList.push(v)



            this.cbList.push(v)
            this.mealDifferIdsList.push(v.id)
            this.timecurrent.push(i)

          });

          this.timecurrent.sort()
        })
      },
      getOutletsIdList() {
        let methods = 'get'
        let url = this.api.getoutlets + '?posCode=' + localStorage.getItem('posCode')
        this.$axios({
          methods,
          url
        }).then(res => {
          console.log('营业点id', res.data.data);
          this.cantList = []
          this.outletsIdsList = []
          res.data.data.forEach((v, i) => {

            this.$set(v, 'check', true)
            this.cantList.unshift(v)
            this.cantingIDList.push(v.id)
            this.eatCurrent.push(i)
            this.outletsIdsList.push(v)
          });
          this.eatCurrent.sort()
          console.log(222, this.eatCurrent);
        })

      },
      getbookBillList() {
        let methods = 'get'
        let url = this.api.bookBillList
        let data = {
          startDate: this.value1[0],
          endDate: this.value1[1],
          // outletsIds: null,
          outletsId: this.cantingIDList.toString(),
          payOrRefund: this.radio == 'refund' ? 'refund' : null,
          status: this.radio == 'SETTLED' ? 'SETTLED' : this.radio == 'NEED_SETTLED' ? 'NEED_SETTLED' : null,
          orderNum: null
        }


        this.$axios({
          methods,
          url,
          data
        }).then(res => {
          console.log(123124, res.data.data);
          this.bookBillList = []
          res.data.data.forEach((v, i) => {

            this.bookBillList.push(v)

          });
          let height = this.$refs.all.offsetHeight;
          this.bookheight = height - 90

        })
      },
      // 当天时间
      getNowFormatDate() {
        // 当天时间
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        this.timevalue1 = year + seperator1 + month + seperator1 + strDate;

        // 一周后时间
        var day1 = new Date();
        day1.setTime(day1.getTime() + 7 * 24 * 60 * 60 * 1000);
        var ddd = day1.getDate()
        var mmm = (day1.getMonth() + 1)
        if (mmm >= 1 && mmm <= 9) {
          mmm = "0" + mmm;
        }
        if (ddd >= 0 && ddd <= 9) {
          ddd = "0" + ddd;
        }
        var s1 = day1.getFullYear() + "-" + mmm + "-" + ddd;
        this.value1[1] = s1
        this.value1[0] = this.timevalue1




      },

      fetchListData() {
        let url = this.api.bookListWeb
        let methods = 'post'
        let data = {
          begin: this.value1[0],
          end: this.value1[1],
          outletsIds: this.cantingIDList.length ? this.cantingIDList : null,
          status: this.radio,
          queryLike: this.changeInput ? this.changeInput : null
        }
        this.$axios({
          url,
          methods,
          data
        }).then(res => {
          console.log(res);
          if (!res.data.status) {

            this.tableData = res.data.data
            let height = this.$refs.all.offsetHeight;
            this.orderHeight = height - 90
            console.log(this.orderHeight, height);
          }
        })
      },
      bookGrid() {
        let url = this.api.bookGrid
        let methods = 'post'
        let data = {
          begin: this.value1[0],
          end: this.value1[1],
          outletsIds: this.cantingIDList,
          mealDifferIds: this.mealDifferIdsList,
        }
        this.$axios({
          url,
          methods,
          data
        }).then(res => {
          this.loading = false
          if (!res.data.status) {

            res.data.data.forEach((v, i) => {
              v.TopTimeList = this.TopTimeList
              v.showName = 0
              v.zaoNum = 0
              v.zhongNum = 0
              v.wanNum = 0
              v.yeNum = 0
              v.tableVos.forEach((vv, ii) => {
                vv.num = 0

                vv.differVos.forEach((vvv, iii) => {
                  if (vvv.status == 'R') {
                    console.log(vvv);
                    vv.num++
                    if (vvv.differDesc == '早') {
                      v.zaoNum++
                    }
                    if (vvv.differDesc == '中') {
                      v.zhongNum++
                    }
                    if (vvv.differDesc == '晚') {
                      v.wanNum++
                    }
                    if (vvv.differDesc == '夜') {
                      v.yeNum++
                    }
                  }

                })
              })
            })
            this.contentList = res.data.data
          }
        })
      },
      cellStyle({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        return " height:100%";
      },
      addEatingItem(v, i) {
        this.cantingIDList = []
        this.cantList.forEach(res => {
          if (res == v) {
            res.check = !res.check
          }
          if (res.check) {
            this.cantingIDList.push(res.id)

          }
        })

        if (this.styleCurrentList == 2) {
          this.getbookBillList()
        } else if (this.styleCurrentList == 1) {
          this.fetchListData()
        } else if (this.styleCurrentList == 0) {
          this.bookGrid()

        }
      },
      addtimeItem(i) {
        if (this.timecurrent.indexOf(i) != -1) {

          this.timecurrent = this.timecurrent.filter(item => item != i)

        } else {
          this.timecurrent.push(i)
        }
        this.timecurrent.sort()

      },
      gotoadd() {
        let {
          href
        } = this.$router.resolve({
          path: "/reserve/addreserve",
          query: {},
        });
        window.open(href, "_parent");
      },
      styleCheck(i) {
        this.styleCurrentList = i
        if (i == 2) {
          this.getbookBillList()
        } else if (i == 1) {
          this.fetchListData()
        } else if (i == 0) {
          this.bookGrid()

        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .reserve {
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;

    .leftRe {
      // display: flex;
      // flex-direction: column;
      width: 150px;
      height: calc(100vh - 80px);
      // justify-content: space-between;
      border-right: 1px solid #eee;
      // overflow: auto;
      background: #fff;

      .reTop {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0099ff;
        border-bottom: 1px solid #eaeaea;
        height: 66px;
        line-height: 66px;
        text-align: center;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-around;
        align-items: center;
      }

      .eatingAll {
        display: flex;
        flex-direction: column;
        align-items: center;
        border-bottom: 1px solid #eaeaea;
        padding-bottom: 20px;
        max-height: 450px;
        overflow: auto;

        .eatingItem {
          width: 130px;
          height: 66px;
          background: #eeeeee;
          border-radius: 6px;
          text-align: center;
          line-height: 66px;
          font-size: 16px;
          margin: 5px 0;
          color: #666666;
          cursor: pointer;

        }

        .eatingCurrent {
          background: #0099ff;
          color: #fff;
        }
      }

      .timeAll {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 20px;

        .timeItem {
          width: 130px;
          height: 66px;
          background: #eeeeee;
          border-radius: 6px;
          text-align: center;
          line-height: 66px;
          font-size: 16px;
          margin: 5px 0;
          color: #666666;
          cursor: pointer;
        }

        .timeCurrent {
          background: #0099ff;
          color: #fff;
        }

        .yandq {
          // display: flex;
          margin-top: 5px;

          div:nth-child(1) {
            width: 100px;
            // margin-right: 5px;
            height: 40px;
            background: #ff9900;
            border-radius: 6px;
            text-align: center;
            line-height: 40px;
            color: #fff;
            margin-top: 10px;
          }

          div:nth-child(3) {
            width: 100px;
            height: 40px;
            background: #0099ff;
            border-radius: 6px;
            text-align: center;
            line-height: 40px;
            color: #fff;
            margin-top: 10px;

          }

          div:nth-child(2) {
            width: 100px;
            height: 40px;
            background: #eee;
            border-radius: 6px;
            text-align: center;
            line-height: 40px;
            color: #000;
            border: 1px solid #999;
            margin-top: 10px;

          }

          div:nth-child(4) {
            width: 100px;
            height: 40px;
            background: #ff0000;
            border-radius: 6px;
            text-align: center;
            line-height: 40px;
            color: #FFF;
          }
        }
      }

      .leftBottom {
        margin: 20px auto 10px;

        span {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #666666;
        }


      }
    }

    .rightMain {
      flex: 1;
      background: #fff;
      // max-height: calc(100vh - 140px);
      // min-height: calc(100vh - 140px);
      height: calc(100vh - 80px);

      // border-radius: 20px;
      .rightTop {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 66px;
        border-bottom: 1px solid #eaeaea;

        .Screening {
          display: flex;
          justify-content: space-around;
          align-items: center;
          height: 66px;
          width: 900px;

        }

        .FunctionalityBtn {
          margin-right: 15px;
          display: flex;

          .feffBtn {
            width: 140px;
            height: 40px;
            background: linear-gradient(225deg, #ffbe34 0%, #fe812f 100%);
            box-shadow: 0px 2px 10px 0px rgba(254, 137, 47, 0.3);
            border-radius: 38px;
            text-align: center;
            cursor: pointer;
            color: #fff;
            line-height: 40px;
            margin: 0 5px;
          }

          .blueBtn {
            width: 80px;
            height: 40px;
            background: #0099ff;
            box-shadow: 0px 2px 5px 0px rgba(0, 153, 255, 0.3);
            margin: 0 5px;
            border-radius: 30px;
            text-align: center;
            cursor: pointer;
            color: #fff;
            line-height: 40px;
          }
        }
      }

      .atrialState {
        padding: 0 20px;
        font-size: 16px;
        color: #666;
        position: relative;



        .mainDisplay {
          overflow: auto;
          position: relative;
          display: flex;
          padding: 10px 0 0 0;

          // width: 800px;
          width: calc(100vw - 203px);
          max-height: calc(100vh - 237px);
          min-height: calc(100vh - 170px);
          // scrollbar-width: thin;
          // scrollbar-color: #6969dd #e0e0e0;

          .ssss {
            position: sticky;
            left: 0px;
            background: #fff;
            z-index: 20;

            .topLeft {
              background: #fff;

            }

            .topTile {
              width: 120px;

              position: sticky;
              top: -20px;
              background: #fff;
              z-index: 20;
              height: 80px;
              line-height: 80px;
            }

            .topBottom {
              position: sticky;
              bottom: 0px;
              background: #fff;
              z-index: 80;
              height: 80px;
              line-height: 80px;
            }
          }

          .topLeft {
            position: absolute;
            top: 0px;
            width: 140px;
            z-index: 200;
          }

          .topTime {
            display: flex;
            height: 70px;
            align-items: center;
            line-height: 40px;
            position: sticky;
            top: -12px;
            background: #fff;
            z-index: 10;

            .titleDiv {
              display: flex;

              .titleTotal {
                display: flex;
                align-items: flex-end;
                margin-bottom: 10px;
                padding-left: 5px;
              }
            }

            .timeDiv {
              display: flex;
              flex-direction: column;
              width: 286px;
              justify-content: center;

              .zzwyj {
                display: flex;
                margin-bottom: 10px;

                div {
                  width: 68px;
                  text-align: center;
                }
              }
            }
          }

          .mainContent {
            display: flex;
            align-items: center;
            margin-bottom: 2px;

            .ctDiv {
              display: flex;
              // position: sticky;
              // left: 0px;
              // background: #fff;
              flex-direction: column;
              // margin-right: 6px;

              div {
                width: 120px;
                height: 66px;
                line-height: 66px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }

            .mainColor {
              display: flex;

              .bgColor {
                background: #eee;
                width: 66px;
                height: 66px;
                border-radius: 6px;
                margin: 0 1px;
                cursor: pointer;
              }
            }

            .totalColor {
              width: 55px;
              text-align: center;
              line-height: 66px;
            }
          }

          .bottomTotal {
            position: sticky;
            bottom: 0px;
            height: 78px;
            display: flex;
            align-items: center;
            background: #fff;

            .zzwyj {
              display: flex;

              div {
                width: 66px;
                text-align: center;
              }
            }
          }
        }

        .mainDisplay::-webkit-scrollbar {

          width: 10px;
          height: 10px;
        }

        // scrollbar-width: thin;
        // scrollbar-color: #6969dd #e0e0e0;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .el-table {
    font-size: 16px;
  }

  /deep/ .el-table__header-wrapper .el-checkbox {
    display: none;
  }

  .el-table td,
  .el-table th.is-leaf,
  .el-table--border,
  .el-table--group {
    border-color: transparent;
  }

  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background-color: transparent;
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; // 横向滚动条
    height: 10px; // 纵向滚动条 必写
  }


  /* /deep/.el-table__body {
  height: 100%;
} */
</style>